import script from "./xueqipingyu.vue?vue&type=script&setup=true&lang=js"
export * from "./xueqipingyu.vue?vue&type=script&setup=true&lang=js"

import "./xueqipingyu.vue?vue&type=style&index=0&id=04e2a01c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e2a01c"]])

export default __exports__